export default __webpack_public_path__ + "2681b2e032aea28744ffe2a990565c5b.png";